import { render } from "./UserRegistrationRulesOverview.vue?vue&type=template&id=3727e143&scoped=true&ts=true"
import script from "./UserRegistrationRulesOverview.vue?vue&type=script&lang=ts"
export * from "./UserRegistrationRulesOverview.vue?vue&type=script&lang=ts"

import "./UserRegistrationRulesOverview.vue?vue&type=style&index=0&id=3727e143&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/bouwstenen/Bouwsteen_BuildAndDeploy_Vue_Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3727e143"]])

export default __exports__